import { getEnvironment } from '@heidi/api/config';

import { DEEP_LINK_SCHEME, getDeepLinkScheme } from '@/utils/appConfiguration';

/** Same marketing download URL used by trial and integrations surfaces. */
export const MAGIC_FLOW_DESKTOP_DOWNLOAD_URL = 'https://www.heidihealth.com/download';

const MAGIC_FLOW_DEEP_LINK_HOST = 'magic-flow';

// The id reaches an API path, so a link from outside the app may carry only
// id characters; anything else is not a Magic Flow link.
const TEMPLATE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

// The schemes `buildMagicFlowDeepLink` can produce; on-prem never builds this
// link. Read at call time: `ipc.ts` loads this module in every suite that
// reaches the store, and many of them mock `@/utils/appConfiguration`.
const isBuildableScheme = (scheme: string): boolean =>
  scheme === DEEP_LINK_SCHEME.prod ||
  scheme === DEEP_LINK_SCHEME.staging ||
  scheme === DEEP_LINK_SCHEME.dev;

/** Build `scheme://magic-flow?templateId=…` for the current environment. */
export const buildMagicFlowDeepLink = (templateId: string): string => {
  const scheme = getDeepLinkScheme(getEnvironment());
  return `${scheme}://${MAGIC_FLOW_DEEP_LINK_HOST}?templateId=${encodeURIComponent(templateId)}`;
};

/** Parse a Magic Flow deep link; returns null when the URL is not one. */
export const parseMagicFlowDeepLink = (url: string): { templateId: string } | null => {
  try {
    const parsed = new URL(url);
    if (!isBuildableScheme(parsed.protocol.replace(/:$/, ''))) return null;
    if (parsed.hostname !== MAGIC_FLOW_DEEP_LINK_HOST) return null;
    const templateId = parsed.searchParams.get('templateId');
    if (templateId == null || !TEMPLATE_ID_PATTERN.test(templateId)) return null;
    return { templateId };
  } catch {
    return null;
  }
};
